import { VenueAreas } from 'components/VenueAreas/VenueAreas'
import { NextPage } from 'next'
import React from 'react'

const OTHFloors: NextPage = () => {
  return (
    <VenueAreas
      name="Oriental Teahouse"
      areas={[
        {
          title: 'Delivery menu',
          image: '/static/avc/imasfsgge-xlg.jpg',
          url: 'https://www.mryum.com/orientalteahouse-b/delivery/main-menu',
        },
        {
          title: 'Brunswick pick-up',
          image: '/static/avc/imthage-xlg.jpg',
          url: 'https://www.mryum.com/orientalteahouse-b/pickup/main-menu',
        },
        {
          title: 'Little Collins St pick-up',
          image: '/static/avc/jhlimage-xlg.jpg',
          url: 'https://www.mryum.com/orientalteahouse-lc/pickup/main-menu',
        },
      ]}
    />
  )
}

export default OTHFloors
